import config from '../../assets/js/conf/config'
import request from '../../assets/js/utils/request'

/** 查询商家自维护退货地址 */
export function getMerchantAddressDetail(data) {
	return request.get(config.baseApiB + '/api/v1/wxshop/merchant-address/detail', data || {})
}

/** 保存商家自维护退货地址 */
export function postMerchantAddressSave(data) {
	return request.post(config.baseApiB + '/api/v1/wxshop/merchant-address/save', data || {})
}
